import { useCheckPermissions } from '@/shared';
import { SaveEmpleados } from '../../shared/components/saveEmpledos';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateEmpleadosPageProps = {};

const CreateEmpleadosPage: React.FC<CreateEmpleadosPageProps> = () => {

  useCheckPermissions(PermissionsEnum.api_add_empleado)
  
  return <SaveEmpleados titlePage="Crear Empleados" />;
};

export default CreateEmpleadosPage;
